import { ReactComponent } from "./comment-line.svg";

interface Props {
  fill?: string;
  width?: string;
  height?: string;
}

const CommentLineIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default CommentLineIcon;
